import { Component, OnInit, Output, Input, EventEmitter, AfterContentChecked, OnChanges } from '@angular/core';

import { PackagingMaterialListBE } from './shared/packaging-material.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { PackagingMaterialService } from './packaging-material.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { PackageInstructionAdditionalMHBE } from '../../app/packaging-instruction/shared/packaging-instruction-material.model';
import { PArray } from '../shared/packit-array';
import { SetFocus } from '../../app/shared/setFocus';
import { ChineseChangeValueService } from '../chinese-change-value.service';


@Component({
    moduleId: module.id,
    selector: 'search-packaging-material-dlg',
    templateUrl: 'search-packaging-material.html',
    providers: [PackagingMaterialService,ChineseChangeValueService],
})
export class PackagingMaterialSearchDlgComponent implements OnInit, AfterContentChecked, OnChanges {
    // Data set vars
    @Output() materialDlgExecuteCommand: EventEmitter<PackagingMaterialListBE[]> = new EventEmitter<PackagingMaterialListBE[]>();
    @Output() materialExecuteCommand: EventEmitter<number> = new EventEmitter<number>();
    @Input() isAlreadyAdded: PackageInstructionAdditionalMHBE[] = [];
    @Input() showSelectCheckBoxes: boolean;
    @Input() showSelectRadios: boolean;
    @Input() showEditButtons: boolean;
    @Input() showAsDialog: boolean;

    materialSearchResult: PArray<PackagingMaterialListBE> = new PArray(new Array<PackagingMaterialListBE>());
    selectedMaterialsPArr: PArray<PackagingMaterialListBE> = new PArray(new Array<PackagingMaterialListBE>());
    isAlreadyAddedPArr: PArray<PackageInstructionAdditionalMHBE> = null;
    showCheckBoxes: boolean = false;
    showRadios: boolean = false;
    showButtons: boolean = false;
    showDialog: boolean = true;
    typeDelayTimer: any = null;
    searchKeyStrokeDelay: number = 350;


    searchMaterialText: string = '';
    showMaterialSearchSpinner: boolean = false;
    errorObj: ErrorObject = null;

    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;

    constructor(
        private materialService: PackagingMaterialService,
        private errHandler: ErrorHandlerService,
        public  ChineseChangeValueService:ChineseChangeValueService
    ) {
        errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
    }

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
    }

    ngOnInit(): void {
        document.getElementById("SearchMaterialInput").focus();

    }




    ngAfterContentChecked() {
        // this.isFocusSet = this.setFocus.to("SearchMaterialInput", this.isFocusSet);
    }


    ngOnChanges(): void {
        this.isAlreadyAddedPArr = this.isAlreadyAdded != null
            ? new PArray(this.isAlreadyAdded)
            : null;
        this.showRadios = this.showSelectRadios;
        this.showCheckBoxes = this.showSelectCheckBoxes;
        this.showButtons = this.showEditButtons;
        this.showDialog = this.showAsDialog;
    }

    searchMaterial() {
        this.showMaterialSearchSpinner = true;
        this.materialSearchResult = null;
        this.errorObj = null;
        clearInterval(this.typeDelayTimer);

        this.materialService.searchMaterial(this.searchMaterialText)
            .subscribe(returnObject => this.searchMaterialResult(returnObject));
    }

    searchMaterialResult(returnObject: IReturnObject) {
        this.materialSearchResult = new PArray(new Array<PackagingMaterialListBE>());
        this.selectedMaterialsPArr = new PArray(new Array<PackagingMaterialListBE>());;

        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'MaterialSearchComponent.gsearchMaterialResult', returnObject.ErrorType);
        else
            this.materialSearchResult = new PArray(returnObject.DataList);

        this.showMaterialSearchSpinner = false;
    }

    searchResult() {
        if (this.materialSearchResult != null && this.searchMaterialText.length > 1)
            return this.materialSearchResult.Array();
        else
            return [];
    }

    searchMaterialTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (this.searchMaterialText.length > 1) {

            // If this.typeDelayTimer is not nulll then the  
            // user typed somthing new within time limit so reset timer
            if (this.typeDelayTimer != null)
                clearInterval(this.typeDelayTimer);

            this.typeDelayTimer = setInterval(function () {
                that.searchMaterial();
            }, this.searchKeyStrokeDelay);
        }
        else {
            this.materialSearchResult = new PArray(new Array<PackagingMaterialListBE>());
            clearInterval(this.typeDelayTimer);
        }
    }

    editMaterial(materialId: number) {
        this.materialExecuteCommand.emit(materialId);
    }

    okClose() {
        this.materialDlgExecuteCommand.emit(this.selectedMaterialsPArr.Array());
    }

    closeDlg() {
        this.materialDlgExecuteCommand.emit(null);
    }

    setSelectedMaterial(material: PackagingMaterialListBE): void {
        if (this.showButtons) {
            this.editMaterial(material.Id);
        }
        else if (this.showRadios) {
            this.selectedMaterialsPArr.pop();
            this.selectedMaterialsPArr.push(material);
        }
        else {
            let inx = this.selectedMaterialsPArr.indexOf(material);
            if (inx == -1)
                this.selectedMaterialsPArr.push(material);
            else
                this.selectedMaterialsPArr.removAtIndex(inx);
        }
    }

    isNoSelection(): boolean {
        return this.selectedMaterialsPArr.Array().length == 0;
    }

    isAlreadySelected(materialId: number): boolean {
        let inx = this.isAlreadyAddedPArr != null
            ? this.isAlreadyAddedPArr.getIndexByProperty("MaterialId", materialId)
            : null;
        return inx != null;
    }

    isChecked(materialId: number): boolean {
        let inx = this.selectedMaterialsPArr.getIndexByProperty("Id", materialId);
        return inx != null;
    }

    onSingleAddMaterial(event) {
        if (event.key === "Enter" && this.searchResult().length === 1) {
            this.materialDlgExecuteCommand.emit(this.searchResult());
        }
    }

    onSelectAddMaterial(event) {
        if (event.key === "Enter") {
            this.okClose();
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-material/search-packaging-material.component.ts